import { Tooltip as ChakraTooltip, TooltipProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { cn } from "utils/helpers";

interface CustomTooltipProps extends TooltipProps {
	children: ReactNode;
	className?: string;
	label: ReactNode;
	placement?: TooltipProps["placement"];
	shouldWrapChildren?: boolean;
}

const Tooltip = ({
	label,
	placement,
	className,
	children,
	shouldWrapChildren = true,
	...props
}: CustomTooltipProps) => {
	return (
		<ChakraTooltip
			label={label}
			placement={placement}
			hasArrow
			shouldWrapChildren={shouldWrapChildren}
			className={cn(
				"!border !border-gray-200 !bg-gray-900 !bg-opacity-80 !shadow-lg",
				className
			)}
			{...props}
		>
			{children}
		</ChakraTooltip>
	);
};

export default Tooltip;
